import config from "../config/config"
import { callService } from "./CommonService";

const APIUrlBase = config.apiHost + config.apiBase + 'configurations';

/* Retrieve list of all configurations in the system */
async function getConfigurations() {
    const url = APIUrlBase;
    return await callService(url);
}

/* Retrieve one single configuration data */
async function getConfiguration(configurationId) {
    const url = APIUrlBase + '/' + configurationId;
    return await callService(url);
}

/* Call API service to update a configuration */
async function updateConfiguration(configurationId, data) {
    const url = APIUrlBase + '/' + configurationId;
    const method = 'PATCH';
    const payload = {
        agente_capacitador: data.agente_capacitador,
    };
    return await callService(url, method, payload);
}

/* Call API service to create a configuration */
async function createConfiguration(data) {
    const url = APIUrlBase;
    const method = 'POST';
    const payload = {
        agente_capacitador: data.agente_capacitador,
    };
    return await callService(url, method, payload);
}

export default { getConfigurations, getConfiguration, updateConfiguration, createConfiguration };
